export default __webpack_public_path__ + "static/media/winner_4.701f398b.jpg";